const ServiceReferentiel = {

	getCommunes: function() {

		let communes;

		try {
			communes = require(process.env.REACT_APP_PATH_DATA + '/ref-communes.json');
		} catch (error) {
			console.error(error);
		}
		return communes;
	}

}
export default ServiceReferentiel;